import React, { memo, useMemo } from "react";
import { StoryblokAsset } from "../../interfaces/StoryblokAsset.interface";
import StructuredData from "../StructuredData/StructuredData";
import { Blok } from "../../interfaces/Blok.interface";

interface OrganisationStructuredDataBlokProps extends Blok {
  logo: StoryblokAsset;
}

interface OrganisationStructuredDataProps {
  blok: OrganisationStructuredDataBlokProps;
}

const OrganisationStructuredData: React.FC<OrganisationStructuredDataProps> = ({
  blok: { logo }
}) => {
  const organisationStructuredData = useMemo(() => {
    return {
      "@type": "Organization",
      url: `${process.env.GATSBY_WEBSITE_URL}`,
      logo: logo?.filename
    };
  }, [logo]);

  return <StructuredData>{organisationStructuredData}</StructuredData>;
};

export default memo(OrganisationStructuredData);
